import Markdown from "markdown-to-jsx";
import { useEffect, useState } from "react";

interface TypeEffectProps {
  fullText: string;
  minSpeed?: number;
  maxSpeed?: number;
  className?: string;
  onComplete?: () => void;
  onTextChange?: () => void;
}

export const TypingEffect = ({
  fullText,
  minSpeed = 5,
  maxSpeed = 25,
  onComplete,
  onTextChange,
  className,
}: TypeEffectProps) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (isComplete && onComplete) {
      onComplete();
    }
  }, [isComplete, onComplete]);

  useEffect(() => {
    let currentIndex = -1;
    let timeoutId: NodeJS.Timeout | null = null;

    const typeLetter = () => {
      if (currentIndex < fullText.length) {
        setDisplayedText((prev) => {
          if (!fullText[currentIndex]) return prev;

          return prev + fullText[currentIndex];
        });
        currentIndex += 1;

        const randomSpeed =
          Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed;

        timeoutId = setTimeout(typeLetter, randomSpeed);
      } else {
        setIsComplete(true);
      }
    };

    if (fullText.length > 0) {
      typeLetter();
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [fullText, minSpeed, maxSpeed]);

  useEffect(() => {
    if (onTextChange) onTextChange();
  }, [displayedText, onTextChange]);

  useEffect(() => {
    setDisplayedText("");
    setIsComplete(false);
  }, [fullText]);

  return <Markdown className={className}>{displayedText}</Markdown>;
};
